/**
 * Brain Reducer
 *
 * Creates a Redux reducer for populating the robots.
 */

// Action Types
import actionTypes from '../actionTypes';

// Utilities
import { Add } from '../../util/Misc';

// Dependencies
import dotProp from 'dot-prop-immutable';
import _ from 'lodash';

// Setup initial state with an fleet info object.
const initialState = {
	byId: {},
	allIds: [],
};

// Export the Brain Reducer.
export default (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.ADD_MODULES: {
			const { info, refresh } = action.payload;
			if (refresh) {
				state = dotProp.set(state, `byId`, {});
				state = dotProp.set(state, `allIds`, []);
			}

			return Add(info, state);
			// return state;
		}
		case actionTypes.REMOVE_MODULE: {
			console.log(state);
			const { info } = action.payload;
			let index = _.indexOf(dotProp.get(state, 'allIds'), info);
			if (index !== -1) {
				state = dotProp.delete(state, `allIds.${index}`);
				state = dotProp.delete(state, `byId.${info}`);
			}

			console.log(state);

			return state;
		}
		case actionTypes.UPDATE_MODULE: {
			const { info } = action.payload;
			state = dotProp.set(state, `byId.${info._id}`, info);
			return state;
		}
		case actionTypes.UPDATE_MODULE_BY_ID: {
			const { info, id } = action.payload;
			let brain = dotProp.get(state, `byId.${id}`);
			state = dotProp.set(state, `byId.${id}`, {
				...brain,
				...info,
			});
			return state;
		}
		case actionTypes.CLEAR_MODULES: {
			state = dotProp.set(state, `byId`, {});
			state = dotProp.set(state, `allIds`, []);
			return state;
		}

		default:
			return state;
	}
};
